import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledStatistical = styled.div`
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  padding: 6px 16px;
  &.statistical-blue {
    color: var(--color-blue-108);
  }
  &.statistical-green {
    color: var(--color-primary-108);
  }
  &.statistical-red {
    color: var(--color-red-107);
  }
  &.statistical-yellow {
    color: var(--color-yellow-107);
  }
`

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-gray-110);
`

const StyledNumber = styled.div`
  font-weight: 800;
  font-size: 2rem;
`
interface IProps {
  color?: 'blue' | 'green' | 'red' | 'yellow'
  title?: string
  value?: number | string
  className?: string
}
const ClinicStatistical = (props: IProps) => {
  const { color, title, value, className } = props
  const { t } = useTranslation()
  return (
    <StyledStatistical className={`statistical-${color} ${className}`}>
      <StyledTitle>{t(title || '')}</StyledTitle>
      <StyledNumber>{value}</StyledNumber>
    </StyledStatistical>
  )
}

export default ClinicStatistical
